var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M211.8,228.4l-86.6-86.6l86.6-86.6l-26.7-26.7L71.7,141.7l113.4,113.4L211.8,228.4z"}));
}

ArrowLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
